module.exports = __webpack_public_path__ + "static/media/no-data.a7bc6b18.png";